import { invert } from "lodash";
import urlInfo from "./urlInfo.esm.js";
import { PAGE_FLAVOR } from "./constants.esm.js";
class MortgagePageClassification {
  constructor(pathname) {
    this.flavor = PAGE_FLAVOR.Purchase;
    this.refinance = false;
    this.loanType = void 0;
    if (pathname) {
      const info = urlInfo(pathname);
      this.segments = info.segments;
      this.refinance = info.page === PAGE_FLAVOR.Refinance || info.segments[1] === PAGE_FLAVOR.VARefinance;
      if (info.page === PAGE_FLAVOR.Purchase || info.page === PAGE_FLAVOR.Refinance) {
        this.loanType = this.refinance ? "refinance" : info.segments.includes("purchase") ? "purchase" : void 0;
        if (info.region && info.region.stateAbbreviation) {
          this.stateAbbreviation = info.region.stateAbbreviation;
          this.stateName = info.region.stateName;
          if (info.region.city) {
            this.flavor = PAGE_FLAVOR.City;
            this.city = info.region.city;
          } else {
            this.flavor = PAGE_FLAVOR.State;
          }
        } else if (invert(PAGE_FLAVOR)[info.segments[1]]) {
          this.flavor = info.segments[1];
        } else {
          this.flavor = info.page;
        }
      }
    }
  }
}
export {
  MortgagePageClassification as default
};
